// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"5fd88b56","185":"7a7f4589","196":"e8689f40","599":"2a61dc9a","682":"f395e538","722":"92c3a364"}[chunkId] + ".chunk.js";
};